"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../../../theme"));
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 12px 20px;\n  cursor: pointer;\n  border-bottom: ", ";\n  color: ", ";\n  border-radius: 5px;\n  font-size: 14px;\n\n  ", "\n"], ["\n  padding: 12px 20px;\n  cursor: pointer;\n  border-bottom: ", ";\n  color: ", ";\n  border-radius: 5px;\n  font-size: 14px;\n\n  ", "\n"])), function (_a) {
    var separator = _a.separator;
    return separator ? "1px solid ".concat(theme_1.default.colorsPalette.gray.superLight) : "none";
}, function (props) {
    return props.default ? theme_1.default.colorsPalette.gray.default : "inherit";
}, function (props) {
    if (props.default) {
        return "\n      display: flex;\n      align-items: center;        \n      &:hover {\n        background-color: ".concat(!props.separator ? theme_1.default.colorsPalette.blue.lighter : "none", ";\n        color: ").concat(theme_1.default.colorsPalette.blue.default, ";\n      }\n    ");
    }
});
exports.MainContainer = MainContainer;
var templateObject_1;
//# sourceMappingURL=styles.js.map